// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"112":"a9a7754c","523":"cb1608f2","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"112":"81c0bafd898d25e7e666","523":"f997647d5853286c9e7e","532":"f420c194099c3d321dd2","678":"aba55251f9ea31fb3bdc"}[chunkId] + ".js";
};